<form class="filter-container" (ngSubmit)="submitForm()">
    <div class="filter-container-group">
        <label class="filter-container-title">{{ title }} {{ labelWithoutTitle }}</label>
        <div class="range-container">
            <div class="range-inputs">
                <p-inputNumber
                    [(ngModel)]="valueFrom"
                    [placeholder]="valueFrom === null ? 'от' : ''"
                    (ngModelChange)="updateValueFrom($event)"
                    mode="decimal"
                    [suffix]="suffix"
                    name="minPrice"
                    class="filter-input"
                    [min]="valueMin"
                    [max]="valueMax"
                    [showClear]="true"
                    [step]="stepInput"
                />
                <span class="rangeDash">-</span>
                <p-inputNumber
                    [(ngModel)]="valueTo"
                    [placeholder]="valueTo === null ? 'до' : ''"
                    (ngModelChange)="updateValueTo($event)"
                    mode="decimal"
                    [suffix]="suffix"
                    name="maxPrice"
                    class="filter-input"
                    [min]="valueFrom"
                    [max]="valueMax"
                    [showClear]="true"
                    [step]="stepInput"
                />
            </div>
        </div>
    </div>
    <!--        <button type="submit">Filter</button>-->
</form>
